export const contactsData = {
    email: 'umishra841@gmail.com',
    phone: '+91-8093188417',
    address: 'Bangalore, India - 560008 ',

    sheetAPI: ''
}